import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_DIETS_AND_DIET_CATEGORIES_MUTATION } from '../graphql/mutations'
import { transformToSaveDietsAndDietCategoriesArgs } from '../graphql/transformers'
import { SAVE_DIETS_AND_DIET_CATEGORIES } from '../redux/action-types'

const useSaveDietsAndDietCategoriesMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.diets.dietsAndDietCategories,
  )

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_DIETS_AND_DIET_CATEGORIES_MUTATION,
        { data: transformToSaveDietsAndDietCategoriesArgs(data) },
        dispatch,
        SAVE_DIETS_AND_DIET_CATEGORIES,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveDietsAndDietCategoriesMutation
